import { render } from "./playerAmr.vue?vue&type=template&id=3da45a0a&scoped=true"
import script from "./playerAmr.vue?vue&type=script&lang=js"
export * from "./playerAmr.vue?vue&type=script&lang=js"

import "./playerAmr.vue?vue&type=style&index=0&id=3da45a0a&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/staging-package-front-service/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3da45a0a"]])

export default __exports__